import React from 'react';
import { Typography, List, ListItem, ListItemText } from '@mui/material';

interface MessageProps {
  message: any;
}

const MessageOrder: React.FC<MessageProps> = ({ message }) => {
  const orderDetails = message?.content?.product_items || [];
  const totalAmount = orderDetails.reduce(
    (sum: number, item: any) => sum + item.item_price * item.quantity,
    0
  );

  const headerText = message?.content?.header?.text || '';
  const bodyText = message?.content?.body?.text || '';
  const footerText = message?.content?.footer?.text || '';

  return (
    <>
      {headerText && (
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          {headerText}
        </Typography>
      )}

      {bodyText && (
        <Typography variant="body2" sx={{ mb: 2 }}>
          {bodyText}
        </Typography>
      )}

      {orderDetails.length > 0 && (
        <List dense>
          {orderDetails.map((item: any, index: number) => (
            <ListItem key={index} sx={{ px: 0 }}>
              <ListItemText
                primary={`Product ID: ${item.product_retailer_id}`}
                secondary={`Quantity: ${item.quantity}, Price: ₹${item.item_price} ${item.currency}`}
              />
            </ListItem>
          ))}
        </List>
      )}

      {orderDetails.length > 0 && (
        <Typography variant="body2" fontWeight="bold" sx={{ mt: 2 }}>
          Total Amount: ₹{totalAmount} INR
        </Typography>
      )}

      {footerText && (
        <Typography variant="body2" sx={{ mt: 2 }}>
          {footerText}
        </Typography>
      )}
    </>
  );
};

export default MessageOrder;
